import {
  callApexRest
} from '../library/aws'

import {
  paginateItems,
  sortItems
} from '../library/general'

import {
  UPDATE_USER_ATTRIBUTES
} from './../stores/auth'

export const ORDER_NAME_COLUMN = 'orderName'
export const ACCOUNT_NAME_COLUMN = 'accountName'
export const AIRDATE_COLUMN = 'airDate'
export const DUEDATE_COLUMN = 'dueDate'
export const CREATED_DATE_COLUMN = 'createdDate'
export const COMPLETION_DUE_DATE_COLUMN = 'completionDueDate'
export const ORDER_STATUS_COLUMN = 'orderStatus'
export const EPISODE_AND_SOURCE_FILENAME_COLUMN = 'episodeTitleAndFileName'
export const PROGRAM_VERSION_COLUMN = 'programVersion'
export const ORDER_TYPE_COLUMN = 'type'

export const ORDER_NAME_COLUMN_FRIENDLY = 'Order #'
export const ACCOUNT_NAME_COLUMN_FRIENDLY = 'Account'
export const AIRDATE_COLUMN_FRIENDLY = 'Air Date'
export const CREATED_DATE_COLUMN_FRIENDLY = 'Created Date'
export const COMPLETION_DUE_DATE_COLUMN_FRIENDLY = 'Due/Completion Date'
export const ORDER_STATUS_COLUMN_FRIENDLY = 'Status'
export const EPISODE_AND_SOURCE_FILENAME_COLUMN_FRIENDLY = 'Episode | Event'
export const PROGRAM_VERSION_COLUMN_FRIENDLY = 'Program Version'
export const ORDER_TYPE_COLUMN_FRIENDLY = 'Type'

const initialState = {
  fetched: false,
  ordersBelongToPrimaryAccount: false,
  ordersAreBothLiveAndPost: false,
  orders: [],
  subsetOrders: [],
  loading: false,
  error: '',
  hasError: false,
  pageNumber: 1,
  pageSize: 20,
  totalSubsetOrders: 0,
  numberOfPages: 0,
  // default sort direction
  sortColumn: AIRDATE_COLUMN,
  sortDirection: {
    [AIRDATE_COLUMN]: 'desc'
  },
  searchTerm: ''
}

const RESET_STATE = 'orders/RESET_STATE'
const UPDATE_SORT = 'orders/UPDATE_SORT'
const UPDATE = 'orders/UPDATE'

const handler = (state = initialState, action) => {
  const {payload} = action

  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialState,
      }

    case UPDATE:
      return {
        ...state,
        ...payload
      }

    case UPDATE_SORT:
      return {
        ...state,
        sortColumn: payload.sortColumn,
        sortDirection: {
          ...payload.sortDirection
        }
      }

    default:
      return state
  }
}

export const requestOrders = () => {
  return async(dispatch, getState) => {
    dispatch({
      type: RESET_STATE
    })

    dispatch({
      type: UPDATE,
      payload: {
        loading: true,
        hasError: false,
        error: '',
        searchTerm: '',
      }
    })

    try {
      const {
        sortColumn,
        sortDirection,
        pageSize,
        pageNumber,
        searchTerm
      } = getState().stores.orders

      const data = await callApexRest('ORDERS', null, null)

      const {
        orders,
        ordersBelongToPrimaryAccount,
        ordersAreBothLiveAndPost,
        contactFullName,
        contactEmailAddress,
        primaryAccountName,
        primaryPostOpsAccountManagerName,
        primaryPostOpsAccountManagerEmail,
        primaryPostOpsAccountManagerPhone,
        primaryLiveOpsAccountManagerName,
        primaryLiveOpsAccountManagerEmail,
        primaryLiveOpsAccountManagerPhone,
        primaryAccountSalesEngineerName,
        primaryAccountSalesEngineerEmail,
        primaryAccountSalesEngineerPhone,
        showInvoicesTab
      } = data

      dispatch({
        type: UPDATE_USER_ATTRIBUTES,
        payload: {
          contactName: contactFullName,
          contactEmail: contactEmailAddress,
          accountName: primaryAccountName,
          primaryPostOpsAccountManagerName,
          primaryPostOpsAccountManagerEmail,
          primaryPostOpsAccountManagerPhone,
          primaryLiveOpsAccountManagerName,
          primaryLiveOpsAccountManagerEmail,
          primaryLiveOpsAccountManagerPhone,
          primaryAccountSalesEngineerName,
          primaryAccountSalesEngineerEmail,
          primaryAccountSalesEngineerPhone,
          showInvoicesTab
        }
      })

      const subsetOrdersBeforePagination = sortItems(filterOrders(orders, searchTerm), sortColumn, sortDirection[sortColumn])

      const totalSubsetOrders = subsetOrdersBeforePagination.length
      const numberOfPages = Math.ceil(totalSubsetOrders / pageSize)

      subsetOrdersBeforePagination.forEach((f, i) => f['#'] = i + 1)

      const subsetOrders = paginateItems(subsetOrdersBeforePagination, pageNumber, pageSize)

      subsetOrders.forEach((f, i) => f['#'] = i + 1)

      dispatch({
        type: UPDATE,
        payload: {
          fetched: true,
          orders,
          ordersBelongToPrimaryAccount,
          ordersAreBothLiveAndPost,
          subsetOrders,
          numberOfPages,
          totalSubsetOrders
        }
      })
    }
    catch (e) {
      dispatch({
        type: UPDATE,
        payload: {
          error: e.message,
          hasError: true
        }
      })
    }

    dispatch({
      type: UPDATE,
      payload: {
        loading: false
      }
    })
  }
}

// Do Search Filtering First
// Then do sorting
// Then do pagination
// Return subsetOrders

const filterOrders = (orders, searchTerm = '') =>
  orders.filter(f => {
    return (
      (f[ORDER_NAME_COLUMN] && f[ORDER_NAME_COLUMN].toLowerCase().includes(searchTerm.toLowerCase())) ||
      (f[AIRDATE_COLUMN] && new Date(f[AIRDATE_COLUMN]).toLocaleDateString('en-US', {timeZone: 'UTC'}).includes(searchTerm.toLowerCase())) ||
      (f[COMPLETION_DUE_DATE_COLUMN] && new Date(f[COMPLETION_DUE_DATE_COLUMN]).toLocaleDateString('en-US', {timeZone: 'UTC'}).includes(searchTerm.toLowerCase())) ||
      (f[EPISODE_AND_SOURCE_FILENAME_COLUMN] && f[EPISODE_AND_SOURCE_FILENAME_COLUMN].toLowerCase().includes(searchTerm.toLowerCase())) ||
      (f[PROGRAM_VERSION_COLUMN] && f[PROGRAM_VERSION_COLUMN].toLowerCase().includes(searchTerm.toLowerCase())) ||
      (f[ORDER_STATUS_COLUMN] && f[ORDER_STATUS_COLUMN].toLowerCase().includes(searchTerm.toLowerCase())) ||
      (f[ORDER_TYPE_COLUMN] && f[ORDER_TYPE_COLUMN].toLowerCase().includes(searchTerm.toLowerCase()))
    )
  })

export const requestSortOrders = (sortColumn, sortDirection) => {
  return async(dispatch, getState) => {
    const {
      orders,
      pageNumber,
      pageSize,
      searchTerm
    } = getState().stores.orders

    // Search Filtering
    // sorting
    // pagination
    // Return subsetOrders

    const subsetOrdersBeforePagination = sortItems(filterOrders(orders, searchTerm), sortColumn, sortDirection)

    const totalSubsetOrders = subsetOrdersBeforePagination.length
    const numberOfPages = Math.ceil(totalSubsetOrders / pageSize)

    subsetOrdersBeforePagination.forEach((f, i) => f['#'] = i + 1)

    const subsetOrders = paginateItems(subsetOrdersBeforePagination, pageNumber, pageSize)
    subsetOrders.forEach((f, i) => f['#'] = i + 1)

    dispatch({
      type: UPDATE_SORT,
      payload: {
        sortColumn,
        sortDirection: {
          [sortColumn]: sortDirection
        }
      }
    })

    dispatch({
      type: UPDATE,
      payload: {
        subsetOrders,
        numberOfPages,
        totalSubsetOrders
      }
    })
  }
}

export const requestSearch = searchTerm => {
  return async(dispatch, getState) => {
    dispatch({
      type: UPDATE,
      payload: {
        loading: true,
        searchTerm,
        pageNumber: 1
      }
    })

    const {
      orders,
      sortColumn,
      sortDirection,
      pageSize,
      pageNumber
    } = getState().stores.orders

    const subsetOrdersBeforePagination = sortItems(filterOrders(orders, searchTerm), sortColumn, sortDirection[sortColumn])

    const totalSubsetOrders = subsetOrdersBeforePagination.length
    const numberOfPages = Math.ceil(totalSubsetOrders / pageSize)

    subsetOrdersBeforePagination.forEach((f, i) => f['#'] = i + 1)

    const subsetOrders = paginateItems(subsetOrdersBeforePagination, pageNumber, pageSize)
    subsetOrders.forEach((f, i) => f['#'] = i + 1)

    dispatch({
      type: UPDATE,
      payload: {
        loading: false,
        subsetOrders,
        numberOfPages,
        totalSubsetOrders
      }
    })
  }
}

export const requestPageStep = nextPageNumber => {
  return async(dispatch, getState) => {
    const {
      orders,
      pageSize,
      numberOfPages,
      searchTerm,
      sortColumn,
      sortDirection
    } = getState().stores.orders

    if (nextPageNumber <= numberOfPages && nextPageNumber > 0) {
      dispatch({
        type: UPDATE,
        payload: {
          pageNumber: nextPageNumber
        }
      })

      const subsetOrdersBeforePagination = sortItems(filterOrders(orders, searchTerm), sortColumn, sortDirection[sortColumn])

      const totalSubsetOrders = subsetOrdersBeforePagination.length
      const numberOfPages = Math.ceil(totalSubsetOrders / pageSize)

      subsetOrdersBeforePagination.forEach((f, i) => f['#'] = i + 1)

      const subsetOrders = paginateItems(subsetOrdersBeforePagination, nextPageNumber, pageSize)

      dispatch({
        type: UPDATE,
        payload: {
          loading: false,
          subsetOrders,
          numberOfPages,
          totalSubsetOrders
        }
      })
    }
  }
}

export default handler